if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"@shippo/feron","remotes":[]},
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}